import { IgetListThemeApi, IresponseThemeApi } from './';

export class ListingThemesModel implements IresponseThemeApi<IgetListThemeApi> {
  public data = {} as IgetListThemeApi;

  constructor(response: IresponseThemeApi<IgetListThemeApi>) {
    Object.assign(this, response);
  }
}
